export const SUCCESS_MESSAGE = 'Votre opération est effectuée avec succès'
export const ERROR_MESSAGE = 'Votre opération est échouée, veuillez réessayer'
export const CONFLICT_EMAIL_MESSAGE =
    "Votre opération est échouée, veuillez réessayer"
export const TYPES = {
    SUCCESS: 'success',
    ERROR: 'danger',
}
